import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BannerComponent } from '../../../components/banner/banner.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  imports: [BannerComponent, TranslatePipe]
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);

  user?: any;

  constructor() {
    const navigation = this.router.currentNavigation();
    const displayName = navigation?.extras?.state?.['displayName'];
    this.user = {
      customClaims: {
        display_name: displayName
      }
    };
  }
}
